import React, { Suspense } from 'react';
import ProgrammeUsers from '../components/ProgramCoordinator/ProgrammeUsers';
import ProgrammeConfig from '../components/ProgramCoordinator/ProgrammeConfig';
import DiagnosticCenters from '../components/ProgramCoordinator/WellnessDiagnosticsList';
import WellnessProfessionals from '../components/ProgramCoordinator/WellnessProfessionals';
import ProgramTimeline from '../components/ProgramCoordinator/ProgramTimeline';

function PCRoutes({ selectedComponent, handleComponentChange }) {
    let componentToRender;
    console.log('selectedComponent', selectedComponent)
    switch (selectedComponent) {
        case 'ProgrammeUsers':
        case null:
            componentToRender = <ProgrammeUsers />;
            break;
        case 'ProgrammeConfig':
            componentToRender = <ProgrammeConfig />;
            break;
        case 'DiagnosticCenters':
            componentToRender = <DiagnosticCenters />;
            break;
        case 'WellnessProfessionals':
            componentToRender = <WellnessProfessionals />;
            break;
        case 'ProgramTimeline':
            componentToRender = <ProgramTimeline />;
            break;
        default:
            componentToRender = <ProgrammeUsers />;
            break;
    }
    return (
        <Suspense fallback={<div>Loading...</div>}>
            {componentToRender}
        </Suspense>
    );
}

export default PCRoutes;